<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center">id</th>
          <th class="text-left" style="width: 400px"></th>
          <th class="text-left">ライター名</th>
          <th class="text-left">締め切り</th>
          <th class="text-left">レギュレーションID</th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.id">
          <td class="text-center">
            {{ order.id }}
          </td>
          <td class="py-2">
            <v-chip
              class="ma-2 font-weight-bold"
              :color="orderStatusColors[order.status]"
              x-small
              label
            >
             {{ orderI18ns.status[order.status] }}
            </v-chip>
            <v-chip small label outlined>
              {{ order.query }}
            </v-chip>
            <div class="text-subtitle-1 pa-1">
              {{ order.title }}
            </div>
          </td>

          <td>
            <v-chip v-if="order.user" small outlined>
              {{ order.user.name }}
            </v-chip>
          </td>
          <td>
            {{ order.expiredOn | momentDate }}
          </td>
          <td class="text-center">
            {{ order.regulationBundlerId }}
          </td>
          <td class="text-center">
            <v-btn
              class="ma-1"
              tile
              small
              outlined
              color="primary"
              @click="$emit('edit-order', order)"
            >
              <v-icon left small> mdi-pencil </v-icon>
              発注修正
            </v-btn>
          </td>
          <td class="text-center">
            <v-btn
              v-if="order.status === 'not_applied'"
              class="ma-1"
              tile
              small
              outlined
              color="error"
              @click="$emit('delete-order', order)"
            >
              <v-icon left small> mdi-delete </v-icon>
              削除
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import snakecaseKeys from 'snakecase-keys'

export default {
  filters: {
    momentDate: function (val) {
      if (val) {
        return moment(val).format('YYYY/M/D')
      }
    }
  },
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      orderStatusColors: {
        not_applied: '',
        writing: 'primary',
        under_inspection: 'warning',
        under_client_inspection: 'warning',
        completed: 'success'
      }
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser,
      orderI18ns: (state) => snakecaseKeys(state.I18n.enums.order)
    })
  }
}
</script>

<style scoped lang="sass">
th, td
  vertical-align: middle
</style>
